import React from 'react';
import styled from 'styled-components';
import ArrowBottom from 'crehana-icons/ArrowBottom';
import { baseLighter } from 'crehana-ui/styles/colors';

import useCollapse from 'Jsx/Shared/Hooks/useCollapse';

const ArrowWrapper = styled.div<{ isOpen }>`
  will-change: transform;
  transition: 0.3s;
  transform: rotate(${props => (props.isOpen ? '-180deg' : '0deg')});
`;

const ToggleItem: React.FC<{
  title: string;
  children: React.ReactNode;
  className?: string;
  indexChildren?: number;
}> = ({ title, children, className, indexChildren }) => {
  const { getToggleProps, getCollapseProps, isOpen } = useCollapse({
    defaultOpen: indexChildren === 1,
  });

  return (
    <div className={className}>
      <h3
        className="font-subtitle2 flex items-center justify-between outline-none bg-gray-dark-8 px-16 py-12"
        {...getToggleProps()}
      >
        <span>{title}</span>
        <ArrowWrapper isOpen={isOpen}>
          <ArrowBottom size={14} color={baseLighter} />
        </ArrowWrapper>
      </h3>
      {children && (
        <div className="mt-16" {...getCollapseProps()}>
          {children}
        </div>
      )}
    </div>
  );
};

export default ToggleItem;
